import { getClient } from '@/api/api-client';
import type {
    ICopyFilesAndFoldersParams,
    IDocumentFolder,
    IFindDocumentFolders,
    IGenerateFolderStructureParams,
    IMoveFilesAndFoldersParams,
    IUpdateMultipleDocumentsParams,
} from '@condo/domain';

export const fetchDocumentsFolders = async (params?: IFindDocumentFolders['query']): Promise<IDocumentFolder[]> => {
    return getClient('basecamp')
        .get('/documents-folder', { params })
        .then(response => response.data.documentFolders);
};

export const saveDocumentsFolder = async (documentFolder: Partial<IDocumentFolder>): Promise<IDocumentFolder> => {
    return getClient('basecamp')
        .post('/documents-folder', { documentFolder })
        .then(response => response.data.documentFolder);
};

export const moveFilesToFolders = async (data: IMoveFilesAndFoldersParams): Promise<any> => {
    return getClient('basecamp')
        .post('/documents-folder/move', data)
        .then(response => response.data);
};

export const copyFilesToFolders = async (
    data: ICopyFilesAndFoldersParams,
): Promise<{ copiedDocuments: number; copiedFolders: number; operationId: string }> => {
    return getClient('basecamp')
        .post('/documents-folder/copy', data)
        .then(response => response.data.result);
};

export const deleteFolder = async (folderId: number): Promise<any> => {
    return getClient('basecamp')
        .delete(`/documents-folder/${folderId}`)
        .then(response => response.data);
};

export const updateMultipleDocuments = async (params: IUpdateMultipleDocumentsParams): Promise<void> => {
    return getClient('basecamp').patch('/documents', params);
};

export const generateFolderStructure = async (params: IGenerateFolderStructureParams) => {
    return getClient('basecamp').post(`/documents-folder/generate-folder-structure`, params);
};
